<template>
  <a-card :bordered="false">
    <a-table :pagination='false' :loading='listLoading' bordered rowKey='level_name' :columns='columns' :data-source='data'>
      <template v-slot:action="{ record }">
        <a v-has:storePromotedEdit="()=>{formData = record;showEdit = true}" href="javascript:;">修改</a>
      </template>
    </a-table>
  </a-card>
  <a-modal :keyboard="false" :maskClosable='false' :title="formData.level_name" centered :width='800' v-model:visible="showEdit" :footer="null" destroyOnClose>
    <editForm @onsubmit='onsubmit' :formData='formData'></editForm>
  </a-modal>
</template>
<script>
  import { ref, onMounted, inject, reactive, toRefs } from "vue";
  import { message } from "ant-design-vue";
  import { getStoreRebate } from "@/api/store";
  import { iscode } from "@/utils/app";
  import editForm from './form'
  export default {
    components: { editForm },
    name: '',
    setup(props, { emit }) {
      // 列表数据和列头配置
      let data = ref([]);
      const state = reactive({
        showEdit: false,
        listLoading: false,
        total: 0,
        formData:{}
      });
      let columns = [
        {
          title: "门店等级",
          dataIndex: "level",
          key: "level",
        },
        {
          title: "等级名称",
          dataIndex: "level_name",
          key: "level_name",
        },
        {
          title: "推荐门店积分（门店）",
          dataIndex: "invitation_point",
          key: "invitation_point",
           customRender:({record})=>{
                  if(record.is_invitation_point!=0){
                    return record.invitation_point || 0
                  }else{
                     return '无'
                  }
          }
        },
        {
          title: "返单奖励积分（商品）",
          dataIndex: "rebate_point",
          key: "rebate_point",
          customRender:({record})=>{
                  if(record.is_rebate_point!=0){
                    return record.is_fixed ==1 ? record.rebate_point : record.rebate_point_percentage + '%'
                  }else{
                     return '无'
                  }
          }
        },
        {
          title: "下单奖励积分（云店商品）",
          dataIndex: "order_point",
          key: "order_point",
          customRender:({record})=>{
                  if(record.is_order_point!=0){
                    return record.order_reward ==1 ? record.order_point : '订单金额'+ record.order_point_percentage + '%'
                  }else{
                     return '无'
                  }
          }
        },
        {
          title: "操作",
          key: "action",
          width: 120,
          slots: { customRender: "action" },
        },
      ];
      const onsubmit = () =>{
        state.showEdit = false
        initData();
      }
      const initData = async () => {
        state.listLoading = true;
        data.value = []
        try {
          let res = await getStoreRebate().then(res => res.data);
          state.listLoading = false;
          if (iscode(res)) {
            data.value = res.data;
            state.total = res.data.total;
          } else {
            message.error(res.msg);
          }
        } catch (e) {
          state.listLoading = false;
        }
      };
      onMounted(() => {
        // 查看是否有留存状态，有则替换
        initData();
      });
      return {
        ...toRefs(state),
        data,
        columns,
        onsubmit
      };
    },
  };
</script>